const LABEL_SNIPPET_MAX_LENGTH = 60

type DraftActionAsset = {
  __typename?: string
  image?: { altText?: string | null; isAnimated?: boolean } | null
}

type DraftIdentity = {
  text?: string | null
  title?: string | null
  channelName?: string | null
  createdAtLabel: string
  assets: readonly DraftActionAsset[]
}

export function draftActionLabels(identity: DraftIdentity): {
  editLabel: string
  moreActionsLabel: string
} {
  const subject = draftSubject(identity)
  return {
    editLabel: `Edit draft ${subject}`,
    moreActionsLabel: `More actions for draft ${subject}`,
  }
}

function draftSubject({
  text,
  title,
  channelName,
  createdAtLabel,
  assets,
}: DraftIdentity): string {
  const [firstAsset] = assets
  const snippet =
    labelSnippet(text) ||
    labelSnippet(title) ||
    labelSnippet(firstAsset?.image?.altText)
  const channel = channelName?.trim()
  return [
    snippet ? `"${snippet}"` : mediaKind(firstAsset),
    channel ? `for ${channel}` : '',
    `created ${createdAtLabel}`,
  ]
    .filter(Boolean)
    .join(' ')
}

function mediaKind(asset: DraftActionAsset | undefined): string {
  switch (asset?.__typename) {
    case undefined:
      return ''
    case 'ImageAsset':
      return asset.image?.isAnimated ? 'GIF' : 'image'
    case 'VideoAsset':
      return 'video'
    case 'DocumentAsset':
      return 'document'
    default:
      return 'media'
  }
}

function labelSnippet(value: string | null | undefined): string {
  const trimmed = value?.trim() ?? ''
  return trimmed.length > LABEL_SNIPPET_MAX_LENGTH
    ? `${trimmed.slice(0, LABEL_SNIPPET_MAX_LENGTH)}…`
    : trimmed
}
